module.exports = __webpack_public_path__ + "static/alternatives-f02a1e3abdd06da3d50f96ea5c29e600.png";